import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { history } from 'dsilo-ui-components';
import { getMsalInstance, handleRedirect } from '../Login/msalService';
import { Loader } from '../../components/loader';
import jwtService from '../../jwtService';
import { saveAadUserDetails } from '../../store/actions';
import { toast } from 'react-toastify';
import { deleteCookie, getCookie, setCookie } from '../../components/CookieConsent/utils';
import { publishMfaException } from '../../utils/mfaExceptionPublisher';

const MFAComponent = (props) => {
	useEffect(() => {
		let isActive = true;

		const navigateToLogin = (message) => {
			if (!isActive) return;
			console.log('[MFA] Navigating to /login:', message);
			toast.error(message);
			history.push(`/login`);
		};

		const processRedirect = async () => {
			try {
				console.log('[MFA] Redirect effect started');
				const rawMsalAdConfig = localStorage.getItem('adConfig');
				console.log('[MFA] rawMsalAdConfig exists:', !!rawMsalAdConfig);

				if (!rawMsalAdConfig) {
					navigateToLogin('MFA failed during login. Missing AD configuration.');
					return;
				}

				const msalAdConfig = JSON.parse(window.atob(rawMsalAdConfig));
				setCookie('tnc', 1, 1); // TnC Consent will expire after 24hrs or when user logout
				const result = await handleRedirect(msalAdConfig);
				console.log('[MFA] handleRedirect result account exists:', !!result?.account);

				if (!(result && result.account)) {
					navigateToLogin('MFA failed during login. Please try again.');
					return;
				}

				const msalInstance = getMsalInstance(msalAdConfig);
				msalInstance.setActiveAccount(result.account);
				const accessToken = result?.accessToken || result?.idToken || '';
				localStorage.setItem('isAdLogin', 'true');
				jwtService.setSession(accessToken);
				jwtService.startSessionRefreshTimer();
				localStorage.setItem('aad.msal.homeAccountId', result.account.homeAccountId || '');
				if (result.expiresOn) {
					localStorage.setItem('aad.msal.expiresOn', result.expiresOn.toISOString());
				}

				const aadLoginResponse = await jwtService.aadLogin({ accessToken, orgId: msalAdConfig?.orgId });
				const userData = {
					...aadLoginResponse?.data,
					isAdLogin: true,
					tnc: msalAdConfig.tnc
				};
				props.saveAadUserDetails({
					...userData,
					tnc: msalAdConfig.tnc
				});
				// localStorage.removeItem('adConfig');

				if (isActive) {
					console.log('[MFA] Navigating to /apploading after successful AAD login');
					history.push(`/apploading`);
				}
			} catch (cError) {
				console.error('[MFA] Redirect processing failed:', cError);
				await publishMfaException(cError, {
					hasAdConfig: !!localStorage.getItem('adConfig'),
					hasJwtToken: !!localStorage.getItem('jwt_access_token'),
					isAdLogin: localStorage.getItem('isAdLogin') === 'true',
				});
				navigateToLogin('MFA failed during login. Please try again.');
			}
		};

		processRedirect();

		return () => {
			isActive = false;
		};
	}, []);

	return (
		<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: '100vh' }}>
			Authenticating Please wait ...
			<Loader />
		</div>
	)
}


const mapDispatchToProps = {
	saveAadUserDetails
};

const mapStateToProps = ({ user, login, app }) => {
	return {
		login,
		user,
		app
	}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MFAComponent));
